import { styled } from '@mui/styles';
import Box from '@mui/material/Box';
import { theme } from '../../theme';


export const StyledHeader = styled(Box)(({ theme }) => ({
    flex: '0 1 auto',
    '& .HeaderMainStack': {
        backgroundColor: 'transparent',
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: '20px',
        boxShadow: `0 1px 12px ${theme.palette.neutral.light}`,

        '& .HeaderContainer': {
            paddingTop: '18px',
            paddingBottom: '18px',

            '& .tcfLogo': {
                width: '170px',
                height: 'auto'
            },

            '& .HeaderRightStack': {
                flexDirection: 'row',
                gap: '15px',
                alignItems: 'center',

                [theme.breakpoints.down('sm')]: {
                    gap: 'unset'
                },

                '& .MuiTypography-root': {
                    fontSize: '12px'
                },

                '& .HeaderProfileStack': {
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',

                    '& .MuiAvatar-root': {
                        width: '34px', height: '34px'
                    },
                },
            }
        },

    },

}));

export const PaperProps = {
    sx: {
        overflow: 'visible',
        '& .MuiTypography-root': {
            fontSize: '12px'
        },
        '& .MuiListItemIcon-root': {
            minWidth: '25px !important'
        },
        '& .MuiMenuItem-root': {
            '&:hover': {
                color: 'black',
                backgroundColor: `${theme.palette.neutral.light} !important`,
            }
        },
        '& .MuiButtonBase-root': {
            padding: '12px 16px'
        },
        '& .MuiList-root': {
            paddingTop: 0,
            paddingBottom: 0
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
}